export const TRANSITION_STATE = {
  STARTS: "starts",
  ENDS: "ends",
};

export const MILES = "miles";
